import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  SuperModelForm,
  SuperModelListMeta,
  SuperModelManufacturerFilter,
  SuperModelRow,
} from "../types";
import { initialSuperModelForm, initialState } from "./initialState";

export const sliceKey = "superModelState";

type SuperModelListSuccessPayload = {
  data: SuperModelRow[];
  meta: SuperModelListMeta;
};

const superModelSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getSuperModelsList(state) {
      state.loading = true;
      state.error = null;
      state.page = 1;
    },

    getSuperModelsListSuccess(
      state,
      action: PayloadAction<SuperModelListSuccessPayload>
    ) {
      state.loading = false;
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getSuperModelsListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    getNextPageItems(state) {
      if (state.loading || state.meta.currentPage >= state.meta.totalPages) {
        return;
      }
      state.loading = true;
      state.error = null;
      state.page = state.meta.currentPage + 1;
    },

    getNextPageItemsSuccess(
      state,
      action: PayloadAction<SuperModelListSuccessPayload>
    ) {
      state.loading = false;
      state.list = state.list.concat(action.payload.data);
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getNextPageItemsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    setManufacturerFilter(
      state,
      action: PayloadAction<SuperModelManufacturerFilter>
    ) {
      state.manufacturerFilter = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialSuperModelForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof SuperModelForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialSuperModelForm;
    },

    addSuperModel(state) {
      state.saving = true;
      state.error = null;
    },

    addSuperModelSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialSuperModelForm;
      state.error = null;
    },

    addSuperModelError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: superModelActions, reducer } = superModelSlice;
